import * as React from "react";
import { useState, useRef, useEffect } from "react";
import classNames from "classnames";
import { CSSTransition } from "react-transition-group";
import { Alert } from "../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../Shared/Entities/Constants/AlertConstants";
import { ClientDashboardFiltersModel } from "../../../../../../Wrap/Models/Domains/Users/DashboardFilter/ClientDashboardFiltersModel";
import { FilterTable } from "./FilterTable";
import { ClientNotificationFiltersModel } from "../../../../../../Wrap/Models/Domains/Users/NotificationFilter/ClientNotificationFiltersModel";
import { DashboardTab, OpreationType } from "../../Resource/Content";

export interface DashboardFiltersDropDownProps {
    onDelete?: (filterId: number) => void;
    onEdit?: (filterId: number) => void;
    onReorder: (newOrder) => void;
    data: ClientDashboardFiltersModel[] | ClientNotificationFiltersModel[];
    cssWrapper?: string;
    currentTabIndex: DashboardTab;
}
export const SavedFiltersDropdown = (props: DashboardFiltersDropDownProps) => {
    const wrapperRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [showErrorMsg, setShowErrorMsg] = useState(false);

    useEffect(() => {
        document.addEventListener("touchstart", handleClickOutside);
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("touchstart", handleClickOutside);
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const onEdit = (row) => {
        props.onEdit(row);
    };

    const handleClickOutside = () => {
        if (wrapperRef && !wrapperRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    const ToggleDropdown = () => {
        setShowErrorMsg(false);
        setIsOpen(!isOpen);
    };
    const CSSClasses = classNames("saved-filters-dropdown more-summary-tile", props.cssWrapper);
    const onChange = (operation: OpreationType, tableIndex: number, row: any) => {
        const _data = [...props.data];
        if (operation === OpreationType.Delete) {
            if (_data.length <= 1) {
                setShowErrorMsg(true);
                return;
            }
            props.onDelete(row.FilterId);
        }
    };
    return (
        <div className={CSSClasses} ref={wrapperRef}>
            <button className="more-summary-tile-button ad d4" onClick={() => ToggleDropdown()} aria-expanded={isOpen}>
                <span className="text">More saved filters</span>
                <span className="icon" aria-hidden={true}></span>
            </button>
            <CSSTransition in={isOpen} timeout={300} unmountOnExit classNames="dropear-csstrans">
                <div className="dropear-list">
                    <span aria-hidden={true} className="dropear-list-sh2" />
                    <div className="dropear-list-panel">
                        <div className="dropear-list-inner">
                            {showErrorMsg && (
                                <Alert alertType={AlertType.Error} message="Filter can't be less than 1" />
                            )}
                            {isOpen && (
                                <FilterTable
                                    onClose={() => setIsOpen(false)}
                                    data={props.data}
                                    onEdit={(id) => onEdit(id)}
                                    onReorder={(d) => props.onReorder(d)}
                                    onChange={(o, i, r) => onChange(o, i, r)}
                                    currentTabIndex={props.currentTabIndex}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </CSSTransition>
        </div>
    );
};
